(() => {
  function isDigital(format) {
    return /digital|download/i.test(format || '');
  }

  function getClosestSection(el) {
    return el.closest('.shopify-section') || document;
  }

  function getVariantSelects(section) {
    return section.querySelector('variant-selects');
  }

  function getOptionSelect(variantSelects, optionName) {
    return Array.from(variantSelects.querySelectorAll('select[name^="options["]')).find(
      (s) => s.name === `options[${optionName}]`
    );
  }

  function findOptionValue(select, predicateUpper) {
    // predicateUpper gets (VALUE_UPPERCASE) => boolean
    const opt = Array.from(select.options).find((o) => predicateUpper((o.value || '').toUpperCase()));
    return opt ? opt.value : null;
  }

  function setOptionsDisabled(select, { disableNo }) {
    const noVal = findOptionValue(select, (v) => v === 'NO');
    Array.from(select.options).forEach((opt) => {
      if (!noVal) {
        opt.disabled = false;
      } else {
        opt.disabled = disableNo ? opt.value === noVal : false;
      }
    });
  }

  function setFieldsState(fieldsWrap, { show, required }) {
    if (!fieldsWrap) return;
    fieldsWrap.style.display = show ? '' : 'none';
    fieldsWrap.querySelectorAll('input').forEach((i) => (i.required = !!required));
  }

  function setNote(noteEl, text) {
    if (!noteEl) return;
    if (text) {
      noteEl.textContent = text;
      noteEl.style.display = 'block';
    } else {
      noteEl.textContent = '';
      noteEl.style.display = 'none';
    }
  }

  function setFramingVisibility(framingSel, show) {
    if (!framingSel) return;
    const wrap =
      framingSel.closest('.product-form__input--dropdown') ||
      framingSel.closest('.product-form__input');
    if (wrap) wrap.style.display = show ? '' : 'none';
  }

  function applyIconicRules(section) {
    const variantSelects = getVariantSelects(section);
    const iconicWrap = section.querySelector('[data-runink-iconic]');
    if (!variantSelects || !iconicWrap) return;

    const formatSel = getOptionSelect(variantSelects, 'FORMAT');
    const framingSel = getOptionSelect(variantSelects, 'FRAMING');

    const pSelect = iconicWrap.querySelector('#runink_personalization');
    const fieldsWrap = iconicWrap.querySelector('#runink_fields');
    const note = iconicWrap.querySelector('#runink_note');

    if (!formatSel || !pSelect) return;

    const digital = isDigital(formatSel.value);

    // DIGITAL: hide framing; PRINT: show framing
    setFramingVisibility(framingSel, !digital);

    const yesVal = findOptionValue(pSelect, (v) => v.startsWith('YES')) || null;

    if (digital) {
      // Helper text for digital only
      setNote(note, 'Personalization required for a digital download.');

      // Force YES (do NOT dispatch change events; avoid racing Dawn)
      if (yesVal) pSelect.value = yesVal;

      // Disable NO + lock the dropdown
      setOptionsDisabled(pSelect, { disableNo: true });
      pSelect.disabled = true;

      // Show + require fields
      setFieldsState(fieldsWrap, { show: true, required: true });
    } else {
      // Clear helper text on print
      setNote(note, '');

      // Unlock dropdown and options
      pSelect.disabled = false;
      setOptionsDisabled(pSelect, { disableNo: false });

      // Show fields only if YES chosen
      const wants = /YES/i.test(pSelect.value || '');
      setFieldsState(fieldsWrap, { show: wants, required: false });
    }
  }

  function applyAll() {
    document.querySelectorAll('.shopify-section').forEach(applyIconicRules);
  }

  // Initial load
  document.addEventListener('DOMContentLoaded', applyAll);

  // Delegated change listener (survives Dawn swaps)
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!(t instanceof HTMLElement)) return;

    const isVariantDropdown = t.matches('select[name^="options["]');
    const isPersonalization = t.matches('#runink_personalization');
    if (!isVariantDropdown && !isPersonalization) return;

    const section = getClosestSection(t);
    requestAnimationFrame(() => applyIconicRules(section));
  });

  // Catch rare DOM swaps without a change event
  const mo = new MutationObserver((mutations) => {
    for (const m of mutations) {
      if (![...m.addedNodes].some((n) => n.nodeType === 1)) continue;
      applyAll();
      break;
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
